import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import onboardPLNPlus from "../../../assets/img/icons/onboard_plnplus.svg";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeCircle,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import BillingAddressForm from "../../../components/BillingAddressForm";
import onboardAppUser from "../../../assets/img/backgrounds/DSC05017-min.jpg";

const AppUserPLNPerksEnrollmentPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const pageRef = useRef();

  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);
  const [newUserName, setNewUserName] = useState<any>(null);
  const [newUserEmail, setNewUserEmail] = useState<any>(null);
  const [newUserPhone, setNewUserPhone] = useState<any>(null);
  const [newUserPhoneReadable, setNewUserPhoneReadable] = useState<any>(null);
  const [newUserShippingAddress, setNewUserShippingAddress] =
    useState<any>(null);
  const [newUserBillingAddress, setNewUserBillingAddress] = useState<any>(null);
  const [present] = useIonToast();

  const submit = async () => {
    setSubmitting(true);

    API.setupRetailLoyaltyAccount(newUserName, newUserEmail, newUserPhone)
      .then(() => {
        setSubmitting(false);

        next();
      })
      .catch((e) => {
        setSubmitting(false);

        present({
          message: `We're having trouble updating your billing address. ${
            e?.response?.data?.message ?? "Please try again."
          }}`,
          duration: 1500,
          position: "bottom",
          icon: closeCircle,
          color: "danger",
          layout: "baseline",
          mode: "ios",
          buttons: [
            {
              text: "OK",
              role: "cancel",
            },
          ],
        });
      });
  };

  const stepIsValid = () => {
    if (!newUserName || !newUserPhone) {
      return false;
    }

    if (!StringUtils.isValidPhone(newUserPhone)) {
      return false;
    }

    return true;
  };

  let loadUser = async () => {
    setLoading(true);

    const user = await StorageUtils.get("user_customer");

    setUser(user);

    const token = await StorageUtils.get("user_authorizationToken");

    API.setAuthToken(token);

    API.getAccount()
      .then(
        async (data: any) => {
          setUser(data?.data?.data?.user);

          // console.log(data?.data?.data?.user);

          // Set the name email and phone from user information
          let phone = StringUtils.formatPhoneNumberWhileTyping(
            data?.data?.data?.user?.phone,
          );

          setNewUserEmail(data?.data?.data?.user?.email?.toLowerCase());
          setNewUserPhone(phone?.value?.split(" ").join(""));
          setNewUserPhoneReadable(phone?.formatted);
          setNewUserName(data?.data?.data?.user?.name);

          if (data?.data?.data?.user?.customer?.shippingAddress) {
            setNewUserShippingAddress(
              data?.data?.data?.user?.customer?.shippingAddress,
            );
          }

          if (data?.data?.data?.user?.customer?.billingAddress) {
            setNewUserBillingAddress(
              data?.data?.data?.user?.customer?.billingAddress,
            );
          }

          await StorageUtils.set("user_customer", data?.data?.data?.user);
        },
        (e) => {
          console.error(e);

          // TODO: error here with reload button
        },
      )
      .finally(() => {
        setLoading(false);
      });
  };

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    loadUser();
  }, []);

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>PLN Perks</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"PLN Perks"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="text-center ion-padding pln-onboarding-container">
          <div className="rounded w-full min-h-[300px] max-h-[300px] max-w-[500px] mx-auto sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
            <img
              src={onboardAppUser}
              alt="App User"
              className="w-full shadow border h-full mx-auto max-h-[300px] rounded-2xl sm:max-h-[350px] object-cover"
            />
          </div>
          <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.25rem]">
            Set Up Your PLN Perks Profile
          </h2>
          <p className="" style={{ fontSize: 18 }}>
            PLN Perks is our free loyalty program that earns you stars for every
            purchase. Stars unlock exclusive rewards and discounts.
          </p>

          <div className="mt-[2rem] mb-[2rem] border-t-[1px] border-gray-100"></div>
          <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.25rem]">
            Contact Information
          </h2>
          <p className="mb-4" style={{ fontSize: 18 }}>
            Enter your name and phone below to complete your profile.
          </p>
          <div>
            <div className="relative mb-4  max-w-[700px] mx-auto">
              {loading ? (
                <>
                  <IonSkeletonText
                    className="rounded h-[50px] w-full"
                    animated={true}
                  ></IonSkeletonText>
                </>
              ) : (
                <>
                  <label
                    htmlFor="name"
                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                  >
                    Name
                  </label>
                  <input
                    auto-capitalize="none"
                    type="text"
                    name="name"
                    id="name"
                    autoComplete="name"
                    className="block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6"
                    placeholder="Jane Appleseed"
                    value={newUserName}
                    required={true}
                    onChange={(event: any) => {
                      setNewUserName(event?.target?.value);
                    }}
                  />
                </>
              )}
            </div>

            <div className="relative mb-4 max-w-[700px] mx-auto">
              {loading ? (
                <IonSkeletonText
                  className="rounded h-[50px] w-full"
                  animated={true}
                ></IonSkeletonText>
              ) : (
                <>
                  <label
                    htmlFor="phone"
                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                  >
                    Phone
                  </label>
                  <input
                    auto-capitalize="none"
                    type="text"
                    name="phone"
                    id="phone"
                    autoComplete="tel"
                    className="block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6"
                    placeholder="+1 555-555-5555"
                    value={newUserPhoneReadable}
                    required={true}
                    onChange={(event: any) => {
                      const res: any = StringUtils.formatPhoneNumberWhileTyping(
                        event?.target?.value?.toString(),
                      );

                      setNewUserPhone(res?.value?.split(" ").join(""));
                      setNewUserPhoneReadable(res?.formatted);
                    }}
                  />
                </>
              )}
            </div>
            <p className="mt-2" style={{ fontSize: 18 }}>
              We'll only use your phone number to keep you updated on your
              orders, appointments, and personalized offers.
            </p>
            <div className="mt-[2rem] mb-[2rem] border-t-[1px] border-gray-100"></div>
            <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.25rem]">
              How It Works
            </h2>
            <div className="my-4 text-center p-3 border rounded-lg max-w-[700px] mx-auto">
              <div className="flex justify-center items-center mb-2.5">
                <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="h-6 w-6 text-white"
                  >
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                  </svg>
                </div>
              </div>
              <div className="text-lg">Earn Stars Every Time You Shop</div>
              <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                Every dollar spent earns you more stars. Each purchase brings
                you closer to rewards.
              </div>
            </div>
            <div className="my-4 text-center p-3 border rounded-lg max-w-[700px] mx-auto">
              <div className="flex justify-center items-center mb-2.5">
                <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="h-6 w-6 text-white"
                  >
                    <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
                    <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
                  </svg>
                </div>
              </div>
              <div className="text-lg">Unlock Exclusive Perks</div>
              <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                Redeem points for discounts, free items, and exclusive offers.
              </div>
            </div>
            <div className="my-4 text-center p-3 border rounded-lg max-w-[700px] mx-auto">
              <div className="flex justify-center items-center mb-2.5">
                <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="h-6 w-6 text-white"
                  >
                    <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
                    <path d="M12 18h.01" />
                  </svg>
                </div>
              </div>
              <div className="text-lg">Simple & Automatic</div>
              <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                No cards to carry. Track your points automatically by entering
                your phone number at checkout.
              </div>
            </div>
            <div className="my-4 text-center p-3 border rounded-lg max-w-[700px] mx-auto">
              <div className="flex justify-center items-center mb-2.5">
                <div className="flex justify-center rounded-full items-center h-[50px] w-[50px] bg-primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="h-6 w-6 text-white"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                    <line x1="9" x2="9.01" y1="9" y2="9" />
                    <line x1="15" x2="15.01" y1="9" y2="9" />
                  </svg>
                </div>
              </div>
              <div className="text-lg">Start Saving Today</div>
              <div className="text-base mt-1" style={{ lineHeight: 1.3 }}>
                Enroll in seconds and enjoy rewards on your very next visit.
              </div>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() && "web"
          }`}
        >
          <IonButton
            disabled={!stepIsValid() || submitting}
            onClick={() => {
              submit();
            }}
            expand="block"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            {submitting ? (
              <IonSpinner className="h-[22px]" name="dots"></IonSpinner>
            ) : (
              "Continue"
            )}
          </IonButton>
          <IonButton
            onClick={async () => {
              await StorageUtils.set("push_permission_prompted", true);

              next();
            }}
            expand="block"
            color="dark"
            fill="clear"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Maybe Later
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default AppUserPLNPerksEnrollmentPage;
